import type { AuthRepositoryPort, InitiateRegistrationInput } from "../ports/auth.repository.port";

export function initiateRegistrationUseCase(repository: AuthRepositoryPort, input: InitiateRegistrationInput) {
  if (!input.termsConsent || !input.dataProcessingConsent) {
    throw new Error("É necessário aceitar os termos e o processamento de dados.");
  }
  return repository.initiateRegistration(input);
}
